
if (typeof window.__divanoAvailabilityBadgeDefined === 'undefined') {
window.__divanoAvailabilityBadgeDefined = true;

class DivanoAvailabilityBadge extends HTMLElement {
  connectedCallback() {
    this._manifest = this._readManifest();
    this._onVariantUpdate = this._onVariantUpdate.bind(this);
    document.addEventListener('variant:update', this._onVariantUpdate);
  }

  disconnectedCallback() {
    document.removeEventListener('variant:update', this._onVariantUpdate);
  }

  _readManifest() {
    const productId = this.dataset.productId;
    if (!productId) return null;
    const scriptEl = document.querySelector(
      `script[data-divano-availability-manifest][data-product-id="${cssEscape(productId)}"]`
    );
    if (!scriptEl) return null;
    try {
      return JSON.parse(scriptEl.textContent || '{}');
    } catch (err) {
      console.warn('[divano-availability-badge] Failed to parse manifest:', err);
      return null;
    }
  }

  _onVariantUpdate(event) {
    if (!this._manifest) return;
    const variant = event.detail && event.detail.resource;
    if (!variant || !variant.id) return;

    const productId = event.detail.data && event.detail.data.productId;
    if (productId && productId !== this.dataset.productId) return;

    const meta = this._manifest.variants[String(variant.id)];
    if (!meta) return;

    const state = this._deriveState(meta);
    if (!state) {
      this.setAttribute('hidden', '');
      this.removeAttribute('aria-label');
      return;
    }
    const labels = this._manifest.labels || {};
    let labelText = labels[state] || '';
    if (state === 'low_stock' && this._manifest.stock_display) {
      const count = Number(meta.count);
      if (labelText.includes('__QTY__')) {
        labelText = Number.isFinite(count) && count > 0 ? labelText.replace('__QTY__', String(count)) : '';
      }
    } else if (state === 'low_stock') {
      const onHand = Number(meta.inventory_quantity);
      labelText = labels.low_stock && Number.isFinite(onHand) && onHand > 0
        ? labels.low_stock.replace('__QTY__', String(onHand))
        : '';
    }
    if (!labelText) {
      this.setAttribute('hidden', '');
      this.removeAttribute('aria-label');
      return;
    }

    this.dataset.state = state;
    const textEl = this.querySelector('[data-role="label"]');
    if (textEl) textEl.textContent = labelText;

    if (state === 'in_stock') {
      this.setAttribute('hidden', '');
    } else {
      this.removeAttribute('hidden');
    }
    this.setAttribute('aria-label', labelText);
  }

  _deriveState(meta) {
    if (meta.lead_time_state) return meta.lead_time_state;
    const productState = this._manifest.product_defaults && this._manifest.product_defaults.lead_time_state;
    if (productState) return productState;
    if (meta.is_made_to_order) return 'preorder';
    if (meta.bridge_state) return meta.bridge_state;
    if (this._manifest && this._manifest.stock_display) {
      return meta.stock === 'low' ? 'low_stock' : null;
    }
    const threshold = Number(this._manifest && this._manifest.low_stock_threshold) || 0;
    if (threshold > 0 && meta.available === true && meta.inventory_tracked === 'shopify') {
      const onHand = Number(meta.inventory_quantity);
      if (Number.isFinite(onHand) && onHand > 0 && onHand <= threshold) return 'low_stock';
    }
    return null;
  }
}

function cssEscape(s) {
  if (window.CSS && typeof window.CSS.escape === 'function') {
    return window.CSS.escape(s);
  }
  return String(s).replace(/[^a-zA-Z0-9_-]/g, (ch) => `\\${ch}`);
}

if (!customElements.get('divano-availability-badge')) {
  customElements.define('divano-availability-badge', DivanoAvailabilityBadge);
}

}
